import { AnalysisProgrammingCodeTemplate } from "../ars_ldm";
import { isDocumentReference } from "./isDocumentReference";
import { isObjectRecord } from "./isObjectRecord";
import { isTemplateCodeParameter } from "./isTemplateCodeParameter";

/**
 * Type guard to check if a value is an AnalysisProgrammingCodeTemplate.
 *
 * @param obj - The value to check.
 * @returns True if the value is an AnalysisProgrammingCodeTemplate.
 */
export const isAnalysisProgrammingCodeTemplate = (
  obj: unknown,
): obj is AnalysisProgrammingCodeTemplate => {
  if (!isObjectRecord(obj)) return false;

  if (typeof obj.context !== "string") return false;
  if (obj.code !== undefined && typeof obj.code !== "string") return false;

  if (obj.documentRef !== undefined && !isDocumentReference(obj.documentRef)) return false;

  if (obj.parameters !== undefined) {
    if (!Array.isArray(obj.parameters)) return false;
    if (obj.parameters.some((parameter) => !isTemplateCodeParameter(parameter))) return false;
  }

  return true;
};
